<template>
    <div>        
        <v-toolbar flat class="sticky-top" color="primary" dark height="auto">
            <v-container>
                <v-row align="center">
                    <v-col cols="12" md="auto">
                        <v-toolbar-title>
                        {{ $t('SmartNavBar.My_products') }}
                        </v-toolbar-title>
                    </v-col>
                    <v-spacer />
                    <v-col cols="12" sm="6" md="auto">
                        <!-- SEARCH -->
                        <v-text-field style="width: 300px; max-width: 300px;"
                            v-model="search"
                            :label="$t('Search')"
                            flat dense outlined background-color="transparent" hide-details clearable
                            prepend-inner-icon="mdi-magnify"
                        ></v-text-field>
                    </v-col>
                    <v-spacer />
                    <v-col cols="12" sm="6" md="auto" >
                        <!-- SORT -->
                        <v-select style="max-width: 250px; width: 250px;"
                            v-model="sortBy"
                            :items="sortOptions"
                            item-text="text"
                            item-value="value"
                            :label="$t('Sort_by')"
                            flat dense outlined background-color="transparent" hide-details
                        ></v-select>
                    </v-col>
                </v-row>                
            </v-container>
        </v-toolbar>
        <v-container>
            <v-row>
                <v-col cols="12">
                    <v-data-iterator 
                        :items="sortedItems" 
                        :items-per-page="-1"
                        hide-default-footer                       
                        :loading="isLoading">                      
                        <template v-slot:default="{ items }">
                            <v-list>
                                <template v-for="(item, index) in items">
                                    <v-list-item :key="item.productCode">
                                        <v-list-item-content>
                                            <v-row align="center">
                                                <v-col cols="auto">
                                                    <v-avatar size="48">
                                                        <v-img :src="item.imageUrl"  />
                                                    </v-avatar>
                                                </v-col>
                                                <v-col>
                                                    <v-row no-gutters align="center" class="py-3">
                                                        <v-col cols="12">
                                                            <span class="font-weight-medium">{{ item.productName }}</span>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <span class="text-caption">{{ $t('Product_code') }}: {{ item.productCode }}</span>
                                                        </v-col>
                                                        <v-col cols="12" v-if="item.minimumQuantity > 1">
                                                            <span class="text-caption">{{ $t('Minimum_quantity') }}: {{ item.minimumQuantity }}</span>
                                                        </v-col>
                                                        <v-col cols="12" v-if="item.validFrom && item.validUntil">
                                                            <span class="text-caption">{{ $t('PriceAgreements.Valid_thru') }}: {{ $d(new Date(item.validUntil), 'short') }}</span>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col style="min-width: 150px;" class="text-right">
                                                    {{ item.unitPrice ? $n(item.unitPrice, 'decimal') + ' ' + item.currency : 'op aanvraag' }}
                                                </v-col>
                                                <v-col cols="auto" class="text-center px-2">
                                                    <v-chip small label v-if="item.discountPerc">
                                                        {{ ('- ' + item.discountPerc + '%') }}
                                                    </v-chip>
                                                </v-col>
                                                <v-col cols="auto" style="min-width: 200px;">
                                                    <cart-item-toolbar v-if="item.unitPrice" :productCode="item.productCode" :minimalOrderQty="item.unitsInBox" />
                                                </v-col>
                                            </v-row>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider :key="'divider-' + item.productCode" v-if="index < items.length - 1"></v-divider>
                                </template>
                            </v-list>
                        </template>
                    </v-data-iterator>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import caas from "@/services/caas";
import CartItemToolbar from "@/components/CartItemToolbar.vue";
export default {
    name: 'MyProducts',
    components: { CartItemToolbar },
    data() {
        return {
            isLoading: false,
            sortBy: 'productName',
            search: '',
            sortOptions: [
                { text: this.$t('Sort_by_code'), value: 'productCode' },
                { text: this.$t('Sort_by_name'), value: 'productName' },
                { text: this.$t('Sort_by_most_ordered'), value: 'orderCount' },
            ],
            items: [],
            tableHeight: this.$store.state.session.ui.contentHeight - 100
        }
    },

    computed: {
        sortedItems() {
            let items = [...this.items];

            // Filter by search
            if (this.search) {
                const searchTerm = this.search.toLowerCase();
                items = items.filter(item => {
                    const productName = (item.productName || '').toLowerCase();
                    const productCode = (item.productCode || '').toLowerCase();
                    return productName.includes(searchTerm) || productCode.includes(searchTerm);
                });
            }

            // Sort
            if (this.sortBy) {
                items.sort((a, b) => {
                    if (this.sortBy === 'orderCount') {
                        // descending for most ordered
                        return (b[this.sortBy] || 0) - (a[this.sortBy] || 0);
                    } else {
                        // ascending for others
                        const valA = a[this.sortBy] || '';
                        const valB = b[this.sortBy] || '';
                        return valA.localeCompare(valB);
                    }
                });
            }
            
            return items;
        }
    },

    created() {
        this.fetchProducts();
    },

    methods: {
        fetchProducts() {
            this.isLoading = true;
            let params = {
                customerId: this.$store.state.session.userInfo.customerId,
                languageCode: this.$store.state.session.ui.locale,
            };
            return caas
            .rpc("fetchCustomerProductCatalog", params)
            .then((response) => {
                if (response.data.success) {
                    this.items = response.data.success.products;
                }
            })
            .finally(() => {
                this.isLoading = false;
            });
        }
    }
}
</script>